<div class="instruments-edit-container">
  <div class="instruments-header">
    {{ 'strategies.instrumentsEditHeader' | translate }}
  </div>
  <div class="instruments-description">
    {{ 'strategies.instrumentsEditDescription' | translate }}
  </div>
  <div class="desktop-aligment">
    <div class="selected-instruments-container">
      <div class="selected-instruments-header">
        {{ 'strategies.selectedInstruments' | translate }}
      </div>

      <div class="form-header">
        <div class="form-label">
          {{ 'strategies.colLabelInstrument' | translate }}
        </div>
        <div class="form-label">
          {{ 'strategies.colLabelRemove' | translate }}
        </div>
      </div>

      <div class="form-inputs">
        @if (!preloaders.instruments) {
          @for (selectedInstrument of instrumentsService.selectedInstruments?.controls; track selectedInstrument.value.id) {
            <libero-selected-instrument-toggler [formName]="selectedInstrument"></libero-selected-instrument-toggler>
          }
        } @else {
          <libero-preload-spinner></libero-preload-spinner>
        }
      </div>

    </div>

    <div class="rounded-corner-bg"><div class="rounded-corner"></div></div>

    <div class="available-instruments-container">
      <div class="desktop-instruments-header-layout">
        <div class="available-instruments-header">
          {{ 'strategies.instrumentsList' | translate }}
        </div>
        @if (!preloaders.instruments) {
          <libero-listable-instruments
            [availableInstruments]="allInstruments"
            [editId]="editId"
          ></libero-listable-instruments>
        } @else {
          <libero-preload-spinner></libero-preload-spinner>
        }
      </div>
    </div>
  </div>

  <div class="save-button-container">
    @if (!preloaders.editStrategyForPMWithStrategies) {
      <libero-button
        [routerLink]="[
          editId ? ('/strategy/edit/' + editId) : '/strategy/new',
          { skipDataInit: !editId, skipServiceInstrumentsReset: true, origin: editStrategyOrigin }
        ]"
        label="{{ 'global.continue' | translate }}"
        btnClasses="btn--primary btn--heading"
        (click)="loadEditStrategyForPMWithStrategies()"
        data-cy="strategy-save-instruments-btn"
      ></libero-button>
    } @else {
      <libero-preload-spinner></libero-preload-spinner>
    }
  </div>

</div>
